import { LargeCommercialPackAction } from '../actions/large_commercial_pack_action';
import { Env } from '../../core/env';
import { ItemAction } from '../actions/item_action';
import { ItemContainer } from '../views/pc/item_container';
import { PriceCalculationAction } from '../actions/price_calculation_action';
import { ItemGroupAreaAction } from '../actions/item_group_area_action';
import { ItemInformationErrorReportAction } from '../actions/item_information_error_report_action';
import { PrintedItemLinkAction } from '../actions/printed_item_link_action';
import { StockAreaAction } from '../actions/stock_area_actions';
import { ReviewButtonAnalytics } from '../../core/actions/analytics/review_button_analytics';
import { RelatedItemAnalytics } from '../../core/actions/analytics/related_item_analytics';
import { CartAddTogether } from '../../core/actions/analytics/cart_add_together_analytics';
import { ItemAnalytics } from '../../core/actions/analytics/item_analytics';
import { ItemImageDetailClickAnalytics } from '../../core/actions/analytics/item_image_detail_click_analytics';
import { ZoomImageAnalytics } from '../../core/actions/analytics/zoom_image_analytics';
import {AddRecommendationItemAction} from "../../search/addRecommendationItem/actions/add_recommendation_item_action";
import {AddRecommendationItemContainer} from "../../search/addRecommendationItem/views/pc/add_recommendation_item_container";
import { RegularDeliveryAction } from '../../core/actions/regular_delivery/regular_delivery_action';
import { RegularItemPriceAction } from '../actions/regular_item_price_action';
import { ComparisonTableAction } from '../../core/actions/comparison_table/comparison_table_action';
import {ItemDetailRrAction} from "../actions/item_detail_rr_action";

window.addEventListener('load', () => {
  // ブラウザバックセレクタ対策
  ItemGroupAreaAction.formReset();
});

// rrエリア表示タイミングを早めるために、表示処理を直接実行する
ItemDetailRrAction.init(Env);

document.addEventListener('DOMContentLoaded', () => {
  ItemDetailRrAction.initAfterDomLoad(Env);
  ItemAction.init(Env, ItemContainer);
  // 緒に買われている商品エリア金額計算
  PriceCalculationAction.init(Env);
  // アイテムグループエリア
  ItemGroupAreaAction.init(Env);
  LargeCommercialPackAction.init();

  // 商品情報誤り報告モーダル
  ItemInformationErrorReportAction.init();
  PrintedItemLinkAction.init(Env.PAGE);
  StockAreaAction.init(Env);
  AddRecommendationItemAction.init(Env, AddRecommendationItemContainer);
  RegularDeliveryAction.init(Env);
  RegularItemPriceAction.init();

  // 比較表
  ComparisonTableAction.init(Env);

  new ReviewButtonAnalytics(ItemAction); // NOSONAR
  new RelatedItemAnalytics(); // NOSONAR
  new CartAddTogether(); // NOSONAR
  new ItemAnalytics(); // NOSONAR
  new ItemImageDetailClickAnalytics(); // NOSONAR
  new ZoomImageAnalytics(); // NOSONAR
});
